export enum StationFrame {
  InternationalSpaceStation,
  UnitedEarthStarfleetConstructionSlip,
  KClassBorderOutpost,
  RegulaClassMultipurposeStation,
  Spacedock,
  FederationStarbase,
  TerakNorType,
  NarendraStationType,
  FederationListeningPost,
  FederationSubspaceCommunicationsRelay,
  Custom,
}

export enum StationFrameAppearance {
  InternationalSpaceStation,
  Drydock,
  KClassBorderOutpost,
  VanguardType,
  StarbaseOneType,
  RegulaClassMultipurposeStation,
  FontanaStation,
  JupiterStation,
  Spacedock,
  SpacedockRevised,
  TerakNorType,
  NarendraStationType,
  FederationCommunicationsArray,
  FederationSubspaceCommunicationsRelay,
}
